import { Entry } from '../Entry'

export function Entry20220519() {
  return (
    <Entry title="19/05/2022 - v3.0.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12623/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
